import * as h3 from 'h3-js';

export function generateMultiPolygonFromSet(hexIds: string[]): any {
    if (!hexIds || hexIds.length === 0) {
        return null;
    }
    try {
        const multiPolygon = h3.cellsToMultiPolygon(hexIds, true);
        return multiPolygon;
    } catch (error) {
        console.error('Error generating multi-polygon from hexIds:', error);
        return null;
    }
} 